export default {
  VIEWBOX_BUTTON_BACK: "viewbox__button-back"
};
